<template>
  <!-- Este picker é diferente porque é uma lista multivalorada
       de CostCenters, mas:

       - nunca existe o item "Todos" (pois não é um filtro de busca,
         mas sim de execução de comando de cálculo de medição)
       - existe um campo para filtrar
       - existem chips para mostrar os selecionados E existem
         os checkboxes na lista (servem para a mesma coisa)
    -->
  <div>
    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Selecione centros de Custo" @close="dismiss" />

        <PanelMultiple
          class="maxh-4"
          strings="Centro de Custo,Centros de Custo;o"
          :items="allItems"
          v-model="copiedValue"
        />

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      label="Centros de Custo"
      icon="mdi-credit-card-outline"
      :orientation="orientation"
      :whenEmpty="cWhenEmpty"
      :value="strValue"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker.vue'
import { CostCenter } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'
import PanelMultiple from 'oderon-vue/cpts/pickers/PanelMultiple.vue'

export default {
  components: {
    BasePicker,
    PanelMultiple
  },
  props: {
    orientation: { type: String, default: 'horizontal' },
    value: {},

    // Quando usado no relatório de medição de CC, é obrigatório,
    // então se estiver vazio significa "nenhum". Quando usado no
    // relatório de medição de serviços, é opcional, então se
    // estiver vazio significa "todos".
    emptyMeansAll: { type: Boolean, default: false },

    whenEmpty: { type: String }
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: [],
      copiedValue: null
    }
  },
  computed: {
    isEmpty() {
      return this.value == null || this.value.length < 1
    },
    cWhenEmpty() {
      if (this.whenEmpty) return this.whenEmpty

      const horz = this.orientation == 'horizontal'
      if (this.emptyMeansAll) {
        return horz ? '(Todos os centros de custo)' : '(Todos)'
      } else {
        return horz ? '(Nenhum centro de custo)' : '(Nenhum)'
      }
    },
    strValue() {
      if (this.isEmpty) return null
      if (this.value.length == 1) {
        return this.value[0].name || '1 Centro de Custo'
      } else {
        return this.value.length + ' centros de custo'
      }
    }
  },
  methods: {
    async fetchData() {
      let rows = await CostCenter.findAll()
      rows = rows.filter((x) => x.deletedAt == null)
      rows = rows.map((r) => ({ id: r.id, name: r.name }))
      this.allItems = orderBy(rows, [['name', 'asc']])
    },

    clear() {
      this.$emit('input', null)
    },

    async openDialog() {
      this.copiedValue = JSON.parse(JSON.stringify(this.value))
      let res = await this.$refs.dialog.$open()
      if (res != null) {
        this.$emit('input', res)
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    apply() {
      this.$refs.dialog.$apply(this.copiedValue)
    }
  }
}
</script>

<style></style>
